import styled from 'styled-components';
import { flex } from '@/styles/minix';

export const PageWrap = styled.div`
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	.align-item {
		${flex('row', 'center')};

		.to-wrap {
			${flex()};
			margin-left: 19px;
			gap: 10px;
			.ant-input {
				max-width: 40px;
				padding: 0 0 0 10px;
				:hover {
					background-color: #ebecf0;
					border: 1px solid #dfe1e6;
				}
			}
		}

		.ant-pagination-item {
			border: none;
			background-color: transparent;
		}
		.ant-pagination-prev .ant-pagination-item-link,
		.ant-pagination-next .ant-pagination-item-link {
			background-color: transparent;
			border: none;
			:hover {
				background-color: #ebecf0;
			}
		}
		.ant-pagination-item a {
			color: #172b4d;
			font-size: 12px;
		}
		.ant-pagination-item-active a {
			color: #0052cc;
		}
	}
	.page-pagin-icon {
		width: 22px;
		height: 22px;
		display: flex;
		align-items: center;
		justify-content: center;
		:hover {
			background-color: #ebecf0;
		}
	}
	.ant-pagination-prev,
	.ant-pagination-next {
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}

	.total-wrap {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
	}
`;
